module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fields selection",
    class: {
      checked: (_vm.current.times_id == _vm.time.id)
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "hourSelection",
      "id": _vm.time.id
    },
    domProps: {
      "value": _vm.time.id
    },
    on: {
      "click": function($event) {
        _vm.updateAddons(_vm.time.id)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.time.id
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n            " + _vm._s(_vm.time.title) + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.time.description))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-057fffda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/builder/PackageOptions/HourSelection.vue
// module id = 152
// module chunks = 0